import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { modulemedia } from 'src/app/models/module/moduledetails';

@Component({
  selector: 'app-module-media-iframe',
  templateUrl: './media-iframe.component.html',
  styleUrls: ['./media-iframe.component.css']
})
export class ModuleMediaIframeComponent implements OnInit {

  @Input() media: modulemedia;
  url: SafeResourceUrl;
  constructor(activatedroute: ActivatedRoute, private sanitizer:DomSanitizer) { 
    // activatedroute.snapshot.root.;
  }

  getUrl(){
    
    console.log(this.url);
    return this.url;
  }

  ngOnInit(): void {
    const url = `${location.protocol}//${location.hostname}:${location.port}${this.media.playerurl}`;
    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    //this.url = `${location.protocol}//${location.hostname}:${location.port}${this.media.playerurl}`;
    console.log('Player url: ' + this.url);
  }

  // getStyle(){
  //   //debugger;
  //   if(this.media && this.media.type && this.media.type.startsWith('audio')){
  //     return {height: '70px'};
  //   }
  //   else{
  //     return {};
  //   }
  // }

}
